import {useEffect, useState} from 'react';
import {Document, Page, pdfjs} from 'react-pdf';
import {TouchScrollable} from 'react-scrolllock';

import cn from 'classnames';

import {HTMLElementId} from '@/constants';
import {useMatchMedia} from '@/hooks/useMatchMedia';
import {Modal} from '@/ui/kit/Modal/Modal';

import {ModalBackButton} from '../ModalBackButton/ModalBackButton';

import s from './PDFModal.module.css';

interface PDFModalProps {
  isOpen: boolean;
  onClose: VoidFunction;
  title: string;
  pdfUrl: {
    smallVersion?: string;
    bigVersion: string;
  };
  className?: string;
}

const PDF_CONTAINER = 'pdf-container';

export function PDFModal({isOpen, title, pdfUrl, onClose, className}: PDFModalProps): JSX.Element | null {
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;
  const [numPages, setNumPages] = useState<number | null>(null);
  const {isMobile} = useMatchMedia();

  const onDocumentLoadSuccess = ({numPages}: {numPages: number}): void => {
    setNumPages(numPages);
  };

  useEffect(() => {
    if (isOpen) {
      const node = document.getElementById(PDF_CONTAINER);
      if (node) {
        const {top} = node.getBoundingClientRect();
        // установка фиксированной ширины блока с просмотром пдф, чтобы он мог быть скроллируемым
        node.style.height = `${window.innerHeight - top}px`;
      }
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <Modal idModalWrapper={HTMLElementId.ClickerGamePageContainer} className={cn(s.root, className)}>
      <div className={s.container}>
        <div className={s.titleWrapper}>
          <h3 className={s.title}>{title}</h3>
          <ModalBackButton onClick={onClose} className={s.backButton} />
        </div>

        <TouchScrollable>
          {/* ref просто отказывается присваиваться ноде */}
          <div id={PDF_CONTAINER} className={s.pdfContent}>
            <Document
              file={isMobile && pdfUrl.smallVersion ? pdfUrl.smallVersion : pdfUrl.bigVersion}
              onLoadSuccess={onDocumentLoadSuccess}
            >
              {Array.from(new Array(numPages), (_, index) => (
                <Page
                  key={`page_${index + 1}`}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  pageNumber={index + 1}
                  className={s.pdfPage}
                />
              ))}
            </Document>
          </div>
        </TouchScrollable>
      </div>
    </Modal>
  );
}
